import { HeaderCommonProps } from "@components/Header/types";
import MyAccountUserHeader from "@pages/MyAccount/components/MyAccountHeader/MyAccountUserHeader";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { cn } from "@util/helpers";

/**
 * MyAccountHeader component displays in the header section as trigger to login or display user profile.
 */
const MyAccountHeader = ({
  textClassName,
  userIconStrokeColor,
}: Pick<
  HeaderCommonProps,
  "textClassName" | "userIconStrokeColor"
>): React.ReactElement => {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const displaySubscribe =
    OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER;

  return (
    <div
      className="relative ml-3 flex-none"
      data-testid="my-account-header-component"
    >
      <div className={cn("relative z-10", { "lg:mr-4": displaySubscribe })}>
        <MyAccountUserHeader
          textClassName={textClassName}
          userIconStrokeColor={userIconStrokeColor}
        />
      </div>
    </div>
  );
};

export default MyAccountHeader;
